import React from 'react';

export default function PrivacyPolicyEN() {
  return (
    <div>
      <h2>
        <strong>DEFINITIONS</strong>
      </h2>
      <p>
        <strong>Seller</strong> – UAB “Imunodiagnostika,” a private legal entity registered in the Register of Legal
        Entities of the Republic of Lithuania, code: 303064228, VAT code: LT100008020911. Registered address: Molėtų g.
        16, Didžioji Riešė, LT-14260, Vilnius district, Lithuania.
      </p>
      <p>
        <strong>Self.co</strong> – the online store available at
        <a target="_blank" rel="noopener noreferrer" href="http://www.self.co/">
          &nbsp;
          <strong>
            <u>www.self.co</u>
          </strong>
        </a>
        .
      </p>
      <p>
        <strong>Buyer</strong> –
      </p>
      <ol>
        <li>
          a legally capable natural person placing an order on Self.co (i.e. a person of legal age whose legal capacity
          is not restricted by a court);
        </li>
        <li>a minor aged 14 to 18 with parental or guardian consent (unless emancipated);</li>
        <li>a legal entity;</li>
        <li>a duly authorized representative of any of the above.</li>
      </ol>
      <p>
        <strong>Seller’s Partner</strong> – a legal entity that:
      </p>
      <ol>
        <li>sells or provides services on Self.co or is involved in fulfilling the Buyer’s order;</li>
        <li>
          runs joint promotions or projects with Self.co on the Self.co website, its own website, or any media channel
          where such activities are presented.
        </li>
      </ol>
      <p>
        <strong>Self.co Accounts</strong> – official Self.co pages on social media platforms such as Facebook, Twitter,
        LinkedIn, etc., where information about Self.co services is shared and Buyer-generated content may be published.
      </p>
      <p>
        <strong>Services</strong> – all services provided to Buyers through Self.co.
      </p>
      <p>
        <strong>Cookie</strong> – a small file sent to a device when a person visits Self.co. This term also includes
        similar tracking technologies.
      </p>
      <p>
        <strong>Browser</strong> – software used to access and display web pages.
      </p>
      <p>
        <strong>Order</strong> – the result of a Buyer registering on Self.co, which creates a record containing
        personal data and order history.
      </p>
      <p>
        <strong>Personal Data</strong> – any information (including data provided in the Patient Questionnaire) relating
        to an identified or identifiable natural person whose identity can be determined directly or indirectly, for
        example, by personal code or by one or more physical, physiological, psychological, economic, cultural, or
        social characteristics.
      </p>
      <p>
        <strong>Patient Questionnaire</strong> – a form completed during the order process, containing information about
        the Patient’s possible allergic reactions and environmental exposures to ensure more accurate test results.
      </p>
      <p>
        <strong>Personal Data Controller</strong> – UAB “Imunodiagnostika.”
      </p>
      <p>
        <strong>Privacy Policy</strong> – this document, which outlines the main rules for collecting, storing,
        processing, and using Personal Data when using Self.co.
      </p>
      <p>
        <strong>Administrator</strong> – the person responsible for the marketing of Self.co.
      </p>
      <p>
        <strong>IP Address</strong> – a unique number assigned to each device connected to the internet, often used to
        identify the country in which the device is located.
      </p>
      <p>
        <strong>Terms</strong> – the current version of the “General Terms and Conditions.”
      </p>
      <p>
        <strong>Direct Marketing</strong> – any activity involving the offering of goods or services or the solicitation
        of opinions by post, telephone, or other direct means.
      </p>

      <h2>
        <strong>GENERAL PROVISIONS</strong>
      </h2>
      <p>
        This Privacy Policy sets out the main rules for collecting, storing, and processing Personal Data when the Buyer
        uses the Services offered on Self.co.
      </p>
      <p>
        The purpose of the Privacy Policy is to protect and safeguard the Personal Data of Self.co Buyers from unlawful
        use.
      </p>
      <p>
        A Buyer is considered to have read and agreed to this Privacy Policy once they give their consent for their
        Personal Data to be processed.
      </p>
      <p>
        This Privacy Policy is available at
        <a target="_blank" rel="noopener noreferrer" href="http://www.self.co/">
          &nbsp;
          <strong>
            <u>www.self.co</u>
          </strong>
        </a>{' '}
        and may be printed at any time. All changes or amendments will be published on Self.co, allowing Buyers to read
        and confirm them each time they register or place an order. The updated Privacy Policy comes into force once
        published on Self.co.
      </p>
      <p>
        Buyers should note that Self.co may contain links to websites owned by other individuals, companies, or
        organizations. The Seller is not responsible for the content of such websites or the methods they use to protect
        privacy. Buyers should review the relevant website’s terms, privacy policy, and other documents before providing
        any personal information.
      </p>
      <p>
        A Buyer may place an order on Self.co by providing the following Personal Data: name, surname, gender, date of
        birth, email address, telephone number, home address, and the clinic where the service will be provided. The
        Buyer is responsible for the accuracy of the Personal Data provided.
      </p>
      <p>The Buyer must complete the Patient Questionnaire to allow the Seller to properly provide the Services.</p>
      <p>
        When placing an order, the Buyer enters their own Personal Data (or the Patient’s data): name, surname, gender,
        date of birth, email address, telephone number, home address, clinic choice, and the Patient Questionnaire. The
        Buyer is solely responsible for the accuracy of this information.
      </p>

      <h2>
        <strong>PROCESSING AND USE OF PERSONAL DATA</strong>
      </h2>
      <p>
        The Buyer agrees that their (and/or the Patient’s) name, surname, gender, date of birth, email address,
        telephone number, home address, Patient Questionnaire data, and IP address may be processed by Self.co for
        business analysis purposes.
      </p>
      <p>
        The Buyer can choose to consent (or not) to their Personal Data being processed for&nbsp;
        <strong>direct marketing purposes</strong> when placing an order.
      </p>
      <p>
        If the Buyer does not wish their data to be used for direct marketing or analytics after purchasing a service,
        they must send an email to&nbsp;<strong>hello@self.co</strong> stating that they do not wish to receive emails
        and/or SMS messages. Direct marketing messages will stop only for the specific email addresses and/or phone
        numbers listed in the request.
      </p>
      <p>
        The Seller confirms that Personal Data will only be processed to provide services available on Self.co
        (including participation in promotions and projects). If the Buyer consents, the data will also be processed for
        business analysis, direct marketing, and detailed reporting purposes. Personal Data used for direct marketing
        will be stored for&nbsp;<strong>3 years</strong> from the date of submission.
      </p>
      <p>
        The Seller undertakes not to disclose Personal Data to third parties, except in the following cases:
        <br />
        &nbsp;a) with the Buyer’s consent;
        <br />
        &nbsp;b) to partners involved in fulfilling the order or providing services;
        <br />
        &nbsp;c) to partners for direct marketing, provided the Buyer has given consent and written agreements ensure
        compliance with Lithuanian data protection laws;
        <br />
        &nbsp;d) to law enforcement authorities, as required by Lithuanian law;
        <br />
        &nbsp;e) if necessary to prevent or investigate criminal activity.
      </p>
      <h3>
        <strong>Buyer’s Rights</strong>
      </h3>
      <p>
        The Buyer has the right to:
        <br />
        &nbsp;a) request and receive a copy of their Personal Data from the Seller by written request;
        <br />
        &nbsp;b) request information on the sources, purposes, and recipients of their Personal Data processed in the
        last year;
        <br />
        &nbsp;c) request the suspension of data processing if it violates the law;
        <br />
        &nbsp;d) refuse data processing (note: in such a case, they will not be able to use Self.co services);
        <br />
        &nbsp;e) withdraw consent for direct marketing at any time.
      </p>
      <p>
        A document confirming identity presented during service collection is used only for identification purposes.
      </p>
      <p>
        By accepting this Privacy Policy, the Buyer agrees that their Personal Data may be shared with the Seller’s
        partners to fulfil the order.
      </p>
      <p>
        Personal Data may be transferred to EU/EEA countries or other countries under the same conditions as within
        Lithuania and only for the purposes stated in this Privacy Policy.
      </p>
      <p>
        According to standard LST EN ISO 15189:2003 for medical laboratories, Personal Data is stored for&nbsp;
        <strong>5 years</strong>, except where legal requirements dictate otherwise.
      </p>
      <p>
        The Seller uses internal technical and organizational measures to protect Personal Data from unauthorized
        access, alteration, disclosure, destruction, identity theft, or fraud. Access to servers is restricted to
        authorized persons via secure password-protected certificates. All Self.co pages requiring Personal Data use
        HTTPS encryption.
      </p>
      <p>
        The Buyer must not disclose Personal Data about themselves, the Patient, or any third party to unauthorized
        persons and must notify the Seller immediately if any breaches occur.
      </p>
      <p>
        The Seller may retain data on its servers if it was used for illegal activities, suspected fraud, identity
        theft, or if the Seller received complaints or observed Terms violations. Such data is deleted only upon legal
        request from authorities.
      </p>
      <p>Requests related to Personal Data processing must be submitted in writing:</p>
      <ol>
        <li>Delivered directly to Molėtų g. 16, Didžioji Riešė, Vilnius district, Lithuania.</li>
        <li>
          Sent by email to&nbsp;<strong>hello@self.co</strong>.<br />
        </li>
      </ol>
      <p>
        The Seller will respond and act on such requests within&nbsp;<strong>30 calendar days</strong>.
      </p>
      <p>The Administrator may use IP addresses for diagnostic and security purposes.</p>

      <h2>
        <strong>CORRECTION, UPDATING, AND DELETION OF PERSONAL DATA</strong>
      </h2>
      <p>
        The Buyer grants Self.co the right to collect, manage, process, and store Personal Data as described in this
        Privacy Policy.
      </p>
      <p>
        Consent to process Personal Data applies only going forward. Once withdrawn, processing will stop, but data may
        still be retained as required by law (e.g., ISO standards require storing questionnaire data for 5 years) or for
        reasons such as national security, public order, crime prevention, investigation, or the protection of legal
        interests.
      </p>
      <p>
        The Buyer has the right to access their data after verifying their identity (e.g., by presenting a passport or
        ID card). To find out what data Self.co has collected, its sources, purposes, and recipients, the Buyer must
        contact Self.co by email. Self.co will respond within&nbsp;<strong>30 days</strong> and provide the data once
        per calendar year free of charge.
      </p>
      <p>
        If the Buyer finds that data was collected illegally or processed for the wrong purposes, they can request
        suspension of processing. If inaccuracies are found, they can request correction within&nbsp;
        <strong>5 business days</strong>.
      </p>
      <p>If Self.co doubts the accuracy of provided data, processing may be suspended until verification.</p>
      <p>
        Requests can be submitted to&nbsp;<strong>hello@self.co</strong>.
      </p>

      <h2>
        <strong>COLLECTION AND STORAGE OF PERSONAL DATA</strong>
      </h2>
      <p>
        To provide full functionality, Self.co may store cookies on the Buyer’s device. Cookies are used to recognize
        returning visitors, store shopping information, and collect website usage statistics. Buyers can view and delete
        cookies at any time. By accepting this Privacy Policy, Buyers consent to cookies being stored. Consent can be
        withdrawn by changing browser settings, but this may affect site functionality.
      </p>
      <h3>
        <strong>Cookies Used</strong>
      </h3>
      <p>
        👉&nbsp;<strong>[Placeholder for Cookie Table – to be inserted here]</strong>
      </p>

      <h2>
        <strong>FINAL PROVISIONS</strong>
      </h2>
      <p>
        This Privacy Policy came into force on&nbsp;<strong>28 June 2016</strong>. Any changes will be communicated in
        accordance with Section 21 of this Policy.
      </p>

      <p>
        ✅&nbsp;<strong>Effective date:</strong> This Privacy Policy applies from the date it is published on
        <a target="_blank" rel="noopener noreferrer" href="http://www.self.co/">
          &nbsp;
          <strong>
            <u>www.self.co</u>
          </strong>
        </a>
        .
      </p>
    </div>
  );
}
